/**
 * Global Declarations.
 */
/// <reference types="vite-plugin-svgr/client" />

/**
 * Imports (Ordered).
 */
import "@radix-ui/themes/styles.css";
import { mountAtlas } from "@/app/mount";
import { globalStateModule } from "@/modules/global-state";
import { globalStateService as commonEditorGlobalStateModule } from "@mem-labs/common-editor";

/**
 * Atlas Setup.
 */
const startAtlas = async () => {
  await globalStateModule.initialize();
  await commonEditorGlobalStateModule.initialize();

  mountAtlas();
};

startAtlas();
